import { render, staticRenderFns } from "./LabelSizeFormGroup.vue?vue&type=template&id=ecf5201e"
import script from "./LabelSizeFormGroup.vue?vue&type=script&lang=js"
export * from "./LabelSizeFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports